import { useFormContext, useWatch } from "react-hook-form";

import { useClients } from "#modules/clients/view/useClients";
import { useMaterialGradeDetails } from "#modules/materials/view/useMaterialGradeDetails";
import { getPropertyOptions } from "#modules/similarPart/domain/getPropertyOptions";
import { FilterOperatorInputController } from "#modules/similarPart/view/filters/FilterOperatorInputController";
import { FilterPropertyInputController } from "#modules/similarPart/view/filters/FilterPropertyInputController";
import { FilterValueInputController } from "#modules/similarPart/view/filters/FilterValueInputController";
import { toleranceList } from "#shared/helpers/ToleranceHelper";
import { Icon } from "#shared/icons/Icon";
import { ActionIcon } from "#shared/view/components/ActionIcon";
import { Grid } from "#shared/view/components/Grid";
import { Expression, FilterQuery } from "shared";

type Props = {
  expression: Expression;
  expressionIndex: number;
  removeFilter: (index: number) => void;
  hasDimensionsFilter: boolean;
};

export const FilterLine = ({ expressionIndex, removeFilter, hasDimensionsFilter }: Props) => {
  const { control } = useFormContext<FilterQuery>();

  const { materialGradeDetails } = useMaterialGradeDetails();
  const { clients } = useClients();

  const selectedProperty = useWatch({
    control,
    name: `filterGroup.expressions.${expressionIndex}.property` as const,
  });

  const propertyOptions = getPropertyOptions({ hasDimensionsFilter });

  const propertyValueType = propertyOptions.find(
    (property) => property.value === selectedProperty,
  )?.type;

  const operators =
    propertyOptions.find((property) => property.value === selectedProperty)?.operators || [];

  return (
    <Grid align="center" w="100%">
      <Grid.Col span={3}>
        <FilterPropertyInputController
          expressionIndex={expressionIndex}
          control={control}
          hasDimensionsFilter={hasDimensionsFilter}
        />
      </Grid.Col>
      <Grid.Col span={4}>
        <FilterOperatorInputController
          operators={operators}
          expressionIndex={expressionIndex}
          control={control}
        />
      </Grid.Col>
      <Grid.Col span="auto">
        <FilterValueInputController
          propertyValueType={propertyValueType}
          expressionIndex={expressionIndex}
          control={control}
          materialGradeDetails={materialGradeDetails}
          toleranceList={toleranceList}
          clients={clients}
        />
      </Grid.Col>
      <Grid.Col span={1}>
        <ActionIcon onClick={() => removeFilter(expressionIndex)}>
          <Icon name="trash" />
        </ActionIcon>
      </Grid.Col>
    </Grid>
  );
};
